import { render, staticRenderFns } from "./ListComponent.vue?vue&type=template&id=31991a0c&scoped=true"
import script from "./ListComponent.vue?vue&type=script&lang=js"
export * from "./ListComponent.vue?vue&type=script&lang=js"
import style0 from "./ListComponent.vue?vue&type=style&index=0&id=31991a0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31991a0c",
  null
  
)

export default component.exports